<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnOtherCompanyCostsSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Auto- en transportkosten')"
                         :calculated-value="data.calculated.statement_other_transport"
                         v-model="data.edit.statement_other_transport"/>

      <TaxReturnTableRow :description="$gettext('Huisvestigingskosten')"
                         :calculated-value="data.calculated.statement_other_house"
                         v-model="data.edit.statement_other_house"/>

      <TaxReturnTableRow :description="$gettext('Onderhoudskosten van overige materiele vaste activa')"
                         :calculated-value="data.calculated.statement_other_maintenance"
                         v-model="data.edit.statement_other_maintenance"/>

      <TaxReturnTableRow :description="$gettext('Verkoopkosten')"
                         :calculated-value="data.calculated.statement_other_sale"
                         v-model="data.edit.statement_other_sale"/>

      <TaxReturnTableRow :description="$gettext('Andere kosten')"
                         :calculated-value="data.calculated.statement_other_other"
                         v-model="data.edit.statement_other_other"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>
